export const JournalTypes = {
  BANK: 'BANK',
  PURCHASE: 'PURCHASE',
  SALE: 'SALE',
  GENERAL: 'GENERAL',
}
